<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 19:43:11
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-24 09:58:14
 * @Description: 动态列表
 -->
<template>
  <div class="list-wrapper" v-loading="loading">
    <ul v-if="newsList.length > 0">
      <li class="item" v-for="(item, index) in newsList" :key="index">
        <div class="img-box">
          <img :src="item.photo" alt="" srcset="" />
        </div>
        <div class="content-box">
          <router-link :to="`content/${item.trendid}`" class="title">{{ item.title }}</router-link>
          <p class="info">
            <span class="date">{{ item.issue_time }}</span>
            <i class="line">|</i>
            <span class="type">原创</span>
          </p>
          <p class="digest">{{ item.summary }}</p>
        </div>
      </li>
    </ul>
    <div class="no-data" v-else>
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'list-wrapper',
  data() {
    return {
      newsList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      this.loading = true;
      try {
        const res = await this.$http.post('cg/commonRequest', {
          method: 'pinfo.trend.list',
          // method: 'content.trend.list',
          token: ''
        });
        if (res.code === 200) {
          this.newsList = res.data.list;
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.list-wrapper {
  ul {
    min-height: 300px;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px dashed #ccc;
    .img-box {
      width: 160px;
      height: 100px;
      margin-right: 20px;
      background: #ccc;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-box {
      flex: 1;
      line-height: 32px;
      .title {
        color: #4f90f5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info {
        font-size: 16px;
        .line {
          margin: 0 10px;
        }
      }
      .digest {
        text-indent: 2em;
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
  .no-data {
    text-align: center;
    font-size: 30px;
    line-height: 300px;
    color: #ccc;
    background: #fff;
  }
}
</style>
